export default __webpack_public_path__ + "static/media/patient-light.f0f61538.svg";